export const button = {
  textAlign: 'right',
}

export const input = {
  width: '100%',
}

export const innerFormGroup = {
  marginLeft: 0,
}
